import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoginRequest } from '../api/login-request';
import { environment } from 'src/environments/environment';
import { ROLES } from '../constants/roles.constant';
import { TrackshipmentService } from 'src/app/demo/service/trackshipment/trackshipment.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.ECO_WASTE_SERVICE_URL;
  private jwtHelper = new JwtHelperService();
  private tokenKey = 'access_token';
  private userKey = 'user-data';
  private userData: any = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private trackShipmentService: TrackshipmentService,
  ) {
    const storedUserData = localStorage.getItem(this.userKey);
    if (storedUserData) {
      this.userData = JSON.parse(storedUserData);
    }
  }

  login(data: LoginRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/Authen/login`, data).pipe(
      tap((response: any) => {
        console.log(response);
        this.userData = response;
        localStorage.setItem(this.tokenKey, response.token);
        localStorage.setItem(this.userKey, JSON.stringify(response));
      })
    );
  }

  changeRole(userId: number, disposerId: number): Observable<any>{
    return this.http.post(`${this.apiUrl}/Authen/ChangeRole?userId=${userId}&disposerId=${disposerId}`, {}).pipe(
      tap((response: any) => {
        console.log(response);
        this.userData = response;
        localStorage.setItem(this.tokenKey, response.token);
        localStorage.setItem(this.userKey, JSON.stringify(response));
      })
    );
  }

  forgetPassword(userData: any): Observable<any> {

    return this.http.put<any>(`${this.apiUrl}/Authen/ForgetPassword?username=${userData.username}&email=${userData.email}`, {});
  }

  verifyForgetPasswordToken(token: string): Observable<any> {

    return this.http.get<any>(`${this.apiUrl}/Authen/VerifyForgetPasswordToken?forgetToken=${token}`);
  }

  chageForgetPassword(userData: any): Observable<any> {
    // const url = `${this.changeOwnPasswordEndpoint}?id=${passwordData.id}&oldPassword=${passwordData.oldPassword}&password=${passwordData.password}&confirmPassword=${passwordData.confirmPassword}`;
    const queryParams = `id=${encodeURIComponent(userData.userId.toString())}&password=${encodeURIComponent(userData.password)}&confirmPassword=${encodeURIComponent(userData.cfPassword)}`;
    const url = `${this.apiUrl}/Authen/ChangeNewPassword?${queryParams}`;

    return this.http.put<any>(url, {});
  }

  private getUserData(): any {
    if (!this.userData) {
      const storedUserData = localStorage.getItem(this.userKey);
      if (storedUserData) {
        this.userData = JSON.parse(storedUserData);
      }
    }
    return this.userData;
  }

  getRoleId(): number | null {
    return this.getUserData()?.user.roleId ?? null;
  }

  getUsername(): string | null {
    return this.getUserData()?.user.username ?? null;
  }

  getRole(): any {
    return this.getUserData()?.user.role ?? null;
  }

  getRoleName(): any {
    return this.getUserData()?.user.roleName ?? null;
  }

  getUserDetail(): any {
    return this.getUserData()?.user.userDetail ?? null;
  }

  getUserId(): any {
    return this.getUserData()?.user.userId ?? null;
  }

  isRegAdmin(): boolean {
    return this.getRoleId() === ROLES.REGADMIN;
  }

  isAdmin(): boolean {
    return this.getRoleId() === ROLES.ADMIN;
  }

  isWasteCo(): boolean {
    return this.getRoleId() === ROLES.WASTECO;
  }

  isDisposer(): boolean {
    return this.getRoleId() === ROLES.DISPOSER;
  }

  isAccount(): boolean {
    return this.getRoleId() === ROLES.ACCOUNT;
  }

  isESS(): boolean {
    return this.getRoleId() === ROLES.ESS;
  }

  isSupportTeam(): boolean {
    return this.getRoleId() === ROLES.SUPPORTTEAM;
  }

  isOperator(): boolean {
    return this.getRoleId() === ROLES.OPERATOR;
  }

  isPurchasing(): boolean {
    return this.getRoleId() === ROLES.PURCHASING;
  }

  logout(): void {
    localStorage.clear();
    this.trackShipmentService.clearCriteria();
    this.router.navigate(['/login']);
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem(this.tokenKey);
    return token && !this.jwtHelper.isTokenExpired(token);
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

}
